module.exports = __webpack_public_path__ + "media/images/page/voice_illust03-2bea757b9936536f35724a1ceb3046e5.png";